import { Plus } from "lucide-react";
import { useTranslation } from "react-i18next";

/**
 * "Después · si seguís vos" — the dashed-bordered card shown below the trail
 * on the base-onboarding brand columns. Previews the post-onboarding DGI
 * configuration sub-flow so the user knows what comes after the 4 quick
 * base steps if they configure technical DGI themselves.
 */
export function OnboardingAfterTrail(): JSX.Element {
  const { t } = useTranslation();
  return (
    <div>
      <div className="fx-onb-trail-after-divider">
        {t("onboarding.afterTrail.divider", "Después · si seguís vos")}
      </div>
      <div className="fx-onb-trail-after-item">
        <span className="num" aria-hidden>
          <Plus />
        </span>
        <span className="label">
          {t("onboarding.afterTrail.label", "Configuración DGI")}
          <span className="sub">
            {t(
              "onboarding.afterTrail.sub",
              "Auto o manual · solo si seguís vos",
            )}
          </span>
        </span>
        <span className="when">
          {t("onboarding.afterTrail.when", "~ 3–12m")}
        </span>
      </div>
    </div>
  );
}
